import { render, staticRenderFns } from "./CriarPedidoDeCompraModal.vue?vue&type=template&id=23fc84e6&scoped=true"
import script from "./CriarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriarPedidoDeCompraModal.vue?vue&type=style&index=0&id=23fc84e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc84e6",
  null
  
)

export default component.exports